/* @cap robe_native_variant_gallery | Two-product pilot: select already-rendered native Shopify variant media; no price, Globo, cart or zoom writes. */
(function () {
  'use strict';
  function start(configNode) {
    if (configNode.dataset.bound) return;
    configNode.dataset.bound = 'true';
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    if (!['10735576678727', '16054518055242', '11208208482631', '11208208646471', '10402508538183', '11207366639943', '11207373259079', '11207373488455', '10402508243271', '10402508407111', '10402508341575', '10402508603719', '10402505228615', '10402505064775', '10402506211655', '10402506309959', '10402506375495', '10402506441031', '10402506637639', '10402506703175', '10402505982279', '10402506506567', '10402506604871', '10402506801479', '10402506768711', '10402506080583', '10402508472647', '10402506015047', '10402506146119', '10402506899783', '10402506998087', '10402507063623', '10402507161927', '10402507096391', '10402506965319', '10402504802631', '10402504868167', '10402504933703', '10402505032007', '10402505130311', '10402505195847', '10402505326919', '10402505392455', '11212938903879', '11212980584775', '11212980879687', '11212981207367', '10402505589063', '10402505654599', '10402505523527', '10402505687367', '10402505883975', '10402505916743', '10402508112199', '10402508177735', '10402503754055', '10402505425223', '10402505490759', '10402505752903', '10402506867015', '10402507227463', '10402507260231', '10402507325767', '10402507358535', '10402507850055', '10402508046663', '10402508308807', '10402508669255', '10735607447879', '10735607480647', '10882528936263', '10970553024839', '11215516795207', '11215507620167'].includes(String(config.productId))) return;
    var product = document.getElementById('MainProduct-' + config.sectionId);
    if (!product || product.dataset.mbRobeGalleryBound || !config.variants) return;
    // The live template contains a hidden native picker and the custom picker with the same ID.
    var picker = product && Array.from(product.querySelectorAll('variant-selects')).find(function (node) { return node.querySelector('.custom-select'); });
    var gallery = document.getElementById('MediaGallery-' + config.sectionId);
    if (!picker || !gallery || typeof gallery.setActiveMedia !== 'function') return;
    var select = picker.querySelector('.custom-select');
    var variantInput = product && product.querySelector('.product-variant-id');
    if (!select || !variantInput) return;
    product.dataset.mbRobeGalleryBound = 'true';
    var sequence = 0;
    // MB8: visible option labels in the existing product lightbox, only for these eight classified products.
    if (["10402505589063", "10402505654599", "10402505523527", "10402505687367", "10402505883975", "10402505916743", "10402508112199", "10402508177735"].includes(String(config.productId))) {
      var optionLabels = new Map();
      // Shopify may serve the same exact file through its CDN or the shop /cdn path.
      function optionImageKey(url) { return new URL(url, location.href).pathname.split('/').pop(); }
      gallery.querySelectorAll('[data-mb-option-source]').forEach(function (node) {
        optionLabels.set(optionImageKey(node.dataset.mbOptionSource), node.textContent.trim());
      });
      var optionBox = document.getElementById('mbLbProd');
      var optionView = optionBox && optionBox.querySelector('img');
      if (optionView && !optionBox.dataset.mbOptionLabelsBound) {
        optionBox.dataset.mbOptionLabelsBound = 'true';
        var optionCaption = document.createElement('p');
        optionCaption.id = 'mb8-lightbox-caption';
        optionCaption.hidden = true;
        optionCaption.style.cssText = 'position:absolute;bottom:1.2rem;left:3rem;right:3rem;margin:0;text-align:center;color:#fff;font-size:14px;line-height:1.4;pointer-events:none';
        optionBox.appendChild(optionCaption);
        function updateOptionCaption() {
          var label = optionLabels.get(optionImageKey(optionView.getAttribute('src') || '/')) || '';
          optionCaption.textContent = label;
          optionCaption.hidden = !label || !optionBox.classList.contains('open');
          if (label) {
            if (!optionView.hasAttribute('data-mb8-alt')) optionView.setAttribute('data-mb8-alt', optionView.getAttribute('alt') || '');
            optionView.alt = label;
            optionView.setAttribute('aria-describedby', optionCaption.id);
            optionView.style.maxHeight = '78vh';
          } else if (optionView.hasAttribute('data-mb8-alt') || optionView.getAttribute('aria-describedby') === optionCaption.id) {
            // Restore the previous alt text and drop the reference together with the ARIA hygiene stash, so it is not written back later.
            optionView.alt = optionView.getAttribute('data-mb8-alt') || '';
            optionView.removeAttribute('data-mb8-alt');
            optionView.removeAttribute('aria-describedby');
            optionView.removeAttribute('data-aria-hyg-describedby');
            optionView.style.removeProperty('max-height');
          }
        }
        new MutationObserver(updateOptionCaption).observe(optionView, { attributes: true, attributeFilter: ['src'] });
        new MutationObserver(updateOptionCaption).observe(optionBox, { attributes: true, attributeFilter: ['class'] });
        updateOptionCaption();
      }
    }

    function showSelectedFront(media) {
      var fronts = new Set(Object.values(config.variants).filter(Boolean).map(String));
      (config.frontMediaIds || []).forEach(function (id) { fronts.add(String(id)); });
      if (config.cleanMediaId) fronts.add(String(config.cleanMediaId));
      function mark(element, id) {
        if (!fronts.has(String(id))) return;
        if (String(id) === String(media)) element.removeAttribute('data-mb-robe-hidden');
        else element.setAttribute('data-mb-robe-hidden', 'true');
      }
      gallery.querySelectorAll('[data-media-id]').forEach(function (element) {
        mark(element, element.dataset.mediaId.slice(config.sectionId.length + 1));
      });
      gallery.querySelectorAll('[data-target]').forEach(function (element) {
        mark(element, element.dataset.target.slice(config.sectionId.length + 1));
      });
      var modal = document.getElementById('ProductModal-' + config.sectionId);
      if (modal) modal.querySelectorAll('[data-media-id]').forEach(function (element) { mark(element, element.dataset.mediaId); });
      // Bild 5 "Tuch des gewaehlten Stoffs": nur das Tuchbild der gewaehlten Variante sichtbar (Bildmappe 24.09.2026).
      if (config.tuch) {
        var tuchSet = new Set((config.tuchMediaIds || []).map(String));
        var tuchWahl = String(config.tuch[String(variantInput.value)] || '');
        var markTuch = function (element, id) { if (!tuchSet.has(String(id))) return; if (String(id) === tuchWahl) element.removeAttribute('data-mb-robe-hidden'); else element.setAttribute('data-mb-robe-hidden', 'true'); };
        gallery.querySelectorAll('[data-media-id]').forEach(function (element) { markTuch(element, element.dataset.mediaId.slice(config.sectionId.length + 1)); });
        gallery.querySelectorAll('[data-target]').forEach(function (element) { markTuch(element, element.dataset.target.slice(config.sectionId.length + 1)); });
        if (modal) modal.querySelectorAll('[data-media-id]').forEach(function (element) { markTuch(element, element.dataset.mediaId); });
      }
      gallery.dataset.mbRobeEnhanced = 'true';
      if (modal) modal.dataset.mbRobeEnhanced = 'true';
      var chosenThumb = gallery.querySelector('[data-target="' + config.sectionId + '-' + media + '"]');
      if (chosenThumb) chosenThumb.parentNode.prepend(chosenThumb);
      if (gallery.elements && gallery.elements.thumbnails) gallery.elements.thumbnails.resetPages?.();
    }

    function fail(id, code) {
      // A missing or failed brand image must never remove the original product photograph.
      var cleanKey = config.sectionId + '-' + config.cleanMediaId;
      var clean = gallery.querySelector('[data-media-id="' + cleanKey + '"]');
      var thumbs = gallery.elements && gallery.elements.thumbnails;
      if (clean && (!thumbs || thumbs.querySelector('[data-target="' + cleanKey + '"]'))) {
        showSelectedFront(config.cleanMediaId);
        gallery.setActiveMedia(cleanKey, true);
      }
      gallery.dispatchEvent(new CustomEvent('mb:robe-gallery-error', { bubbles: true, detail: { variantId: String(id), code: code } }));
      console.error('Robe gallery: ' + code + '; original photograph retained.');
    }

    var bbK6 = document.body && document.body.classList.contains('bb-t1--justiz');
    function showClean() {
      // Waehrend die Front des neuen Tuchs laedt: nie die Marke des vorigen Tuchs stehen lassen.
      if (!config.cleanMediaId) return;
      var cleanKey = config.sectionId + '-' + config.cleanMediaId;
      var clean = gallery.querySelector('[data-media-id="' + cleanKey + '"]');
      var thumbs = gallery.elements && gallery.elements.thumbnails;
      if (clean && (!thumbs || thumbs.querySelector('[data-target="' + cleanKey + '"]'))) {
        showSelectedFront(config.cleanMediaId);
        gallery.setActiveMedia(cleanKey, true);
      }
    }
    function waitDecode(image) {
      // Ohne Zeitlimit: die Front erscheint, sobald sie da ist (K6). Fehler bleiben Fehler.
      if (!image || /(?:no[-_]image|image[-_]not[-_]found|placeholder)/i.test(image.currentSrc || image.src)) return Promise.resolve(false);
      image.loading = 'eager';
      return image.decode().then(function () { return image.naturalWidth > 0 && image.naturalHeight > 0; }, function () {
        if (image.complete && image.naturalWidth > 0) return true;
        return new Promise(function (resolve) {
          image.addEventListener('load', function () { resolve(image.naturalWidth > 0); }, { once: true });
          image.addEventListener('error', function () { resolve(false); }, { once: true });
        });
      });
    }
    function preloadFronts() {
      // Nach dem ersten Bild die uebrigen Fronten leise vorladen (5 x 30-40 KB), damit der Stoffwechsel sofort sitzt.
      Object.values(config.variants).filter(Boolean).forEach(function (m) {
        var el = gallery.querySelector('[data-media-id="' + config.sectionId + '-' + m + '"] img');
        if (el && el.loading === 'lazy') el.loading = 'eager';
      });
    }
    async function imageReady(image) {
      if (!image || /(?:no[-_]image|image[-_]not[-_]found|placeholder)/i.test(image.currentSrc || image.src)) return false;
      image.loading = 'eager';
      var timer;
      try {
        await Promise.race([image.decode(), new Promise(function (_, reject) { timer = setTimeout(function () { reject(new Error('image timeout')); }, 10000); })]);
        return image.naturalWidth > 0 && image.naturalHeight > 0;
      } catch (_) { return false; }
      finally { clearTimeout(timer); }
    }

    function activate(id, resetThumbnailPosition) {
      var stamp = ++sequence;
      queueMicrotask(async function () {
        if (stamp !== sequence || String(variantInput.value) !== String(id)) return;
        var media = config.variants[String(id)];
        if (!media) return fail(id, 'variant-media-unassigned');
        var mediaKey = config.sectionId + '-' + media;
        // Every allowed image and thumbnail must already exist: keeps native zoom bindings intact.
        var main = gallery.querySelector('[data-media-id="' + mediaKey + '"]');
        var thumbs = gallery.elements && gallery.elements.thumbnails;
        var thumb = thumbs && thumbs.querySelector('[data-target="' + mediaKey + '"]');
        if (!main || (thumbs && !thumb)) {
          return fail(id, 'native-media-missing');
        }
        var loaded;
        if (bbK6) {
          var waitImg = main.querySelector('img');
          var interim = setTimeout(function () { if (stamp === sequence && String(variantInput.value) === String(id)) showClean(); }, 1200);
          var slow = setTimeout(function () {
            if (stamp !== sequence) return;
            gallery.dispatchEvent(new CustomEvent('mb:robe-gallery-slow', { bubbles: true, detail: { variantId: String(id), mediaId: String(media) } }));
            console.warn('Robe gallery: brand image slower than 10 s; waiting, original photograph shown meanwhile.');
          }, 10000);
          loaded = await waitDecode(waitImg);
          clearTimeout(interim); clearTimeout(slow);
        } else {
          loaded = await imageReady(main.querySelector('img'));
        }
        if (stamp !== sequence || String(variantInput.value) !== String(id)) return;
        if (!loaded) return fail(id, 'brand-image-failed');
        showSelectedFront(media);
        gallery.setActiveMedia(mediaKey, true);
        if (resetThumbnailPosition && thumbs && thumbs.slider && thumbs.slider.firstElementChild === thumb) {
          var viewer = gallery.elements && gallery.elements.viewer;
          if (viewer && viewer.slider && Array.isArray(viewer.sliderItemsToShow) && viewer.sliderItemsToShow.length > 1 && Number.isFinite(viewer.sliderItemOffset) && viewer.sliderItemOffset > 0) {
            viewer.slider.scrollTo({ left: main.offsetLeft, behavior: 'instant' });
            viewer.update();
          }
          thumbs.slider.scrollTo({ left: 0, behavior: 'instant' });
        }
        gallery.dispatchEvent(new CustomEvent('mb:robe-gallery-ready', { bubbles: true, detail: { variantId: String(id), mediaId: String(media) } }));
      });
    }
    select.addEventListener('click', function (event) {
      var option = event.target.closest('.sme_option[data-value]');
      if (!option || !select.contains(option)) return;
      activate(option.dataset.value, true);
    });
    window.addEventListener('popstate', function () {
      var id = new URL(location.href).searchParams.get('variant') || String(config.defaultVariantId);
      if (!Object.prototype.hasOwnProperty.call(config.variants, id)) id = String(config.defaultVariantId);
      var option = select.querySelector('.sme_option[data-value="' + id + '"]');
      // Reuse the existing complete selector path (price, outer cloth, input). Do not create a second configuration model.
      if (option) option.dispatchEvent(new CustomEvent('click', { bubbles: true, detail: { mbHistoryRestore: true } }));
    });
    activate(variantInput.value);
    if (bbK6) (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(preloadFronts, { timeout: 4000 });
  }
  function boot() {
    customElements.whenDefined('media-gallery').then(function () {
      document.querySelectorAll('[data-mb-robe-gallery-config]').forEach(start);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

/* >>> EG-NAHAUFNAHME 25.09.2026 v2 – Schild gegen die .media>*-Streckung des Themes gesichert (Şönem: „sicherstellen, dass der Kunde versteht, dass das eine Nahaufnahme ist“)
   Tuchbilder (Dateiname enthält „-tuchbild-“) tragen in der Galerie unten links und in jeder Vergrößerung unter dem Bild
   einen kleinen, feinen Hinweis „Tuch in Nahaufnahme · <Tuchname>“. Der Tuchname kommt aus dem vorhandenen Alt-Text.
   Vorschaubildchen bleiben ohne Hinweis. Für Screenreader sagt der Alt-Text es schon, der Hinweis ist aria-hidden.
   Wiederverwendete Bild-Elemente (Lightbox tauscht nur src) werden bei jedem Wechsel neu bewertet. */
(function () {
  if (window.__egNahaufnahme) return; window.__egNahaufnahme = true;
  var EN = /robe-shop\.com$/.test(location.hostname) || (document.documentElement.lang || '').slice(0, 2) === 'en';
  var WORT = EN ? 'Cloth close-up' : 'Tuch in Nahaufnahme';
  var css = document.createElement('style');
  css.textContent =
    '.eg-nah{pointer-events:none;font-size:11px;line-height:1.3;font-weight:500;letter-spacing:.06em;color:#1d1d1f;' +
    'background:rgba(255,255,255,.9);padding:5px 9px;border-radius:2px;max-width:calc(100% - 24px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.eg-nah--bild,.media>.eg-nah.eg-nah--bild,.product__media>.eg-nah.eg-nah--bild{position:absolute!important;top:auto!important;right:auto!important;left:12px!important;bottom:12px!important;width:auto!important;height:auto!important;max-width:calc(100% - 24px)!important;display:inline-block!important;z-index:2}' +
    '.eg-nah--unter{display:block;position:static;margin:10px auto 0;width:max-content;max-width:90%;background:transparent;color:rgba(255,255,255,.86);text-align:center}' +
    '.product-media-modal .eg-nah--unter{color:#3a362f}';
  document.head.appendChild(css);
  function datei(i) { return ((i.currentSrc || i.getAttribute('src') || '').split('?')[0].split('/').pop() || '').replace(/_\d+x\d*(?=\.)/, ''); }
  function gut(a) { return /nahaufnahme|close-up|tuch|cloth/i.test(a || ''); }
  function vorn(a) { var n = (a || '').trim().split(/\s[–—-]\s|,\s/)[0]; return n && n.length < 60 ? n : ''; }
  function name(img) {
    var a = img.getAttribute('alt') || '';
    if (gut(a)) return vorn(a);
    var f = datei(img), andere = Array.prototype.find.call(document.images, function (i) { return i !== img && datei(i) === f && gut(i.getAttribute('alt')); });
    return andere ? vorn(andere.getAttribute('alt')) : '';
  }
  function markieren(img) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    var ist = /-tuchbild-/.test(src) && !img.closest('.thumbnail, .thumbnail-list, button');
    var el = img.__egNahEl;
    if (!ist) { if (el) { el.remove(); img.__egNahEl = null; } return; }
    var t = WORT + (name(img) ? ' · ' + name(img) : '');
    if (el) { if (el.textContent !== t) el.textContent = t; return; }
    var s = document.createElement('span'); s.setAttribute('aria-hidden', 'true'); s.textContent = t;
    var galerie = img.closest('.product__media, .product__media-item');
    if (galerie && !img.closest('.product-media-modal, [class*="lightbox"], dialog')) {
      var box = img.closest('.product__media') || img.parentElement;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      s.className = 'eg-nah eg-nah--bild'; box.appendChild(s);
    } else {
      s.className = 'eg-nah eg-nah--unter'; img.insertAdjacentElement('afterend', s);
    }
    img.__egNahEl = s;
  }
  function alle(root) { root.querySelectorAll('img').forEach(markieren); }
  function start() {
    alle(document);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes') { if (m.target.tagName === 'IMG') markieren(m.target); return; }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'IMG') markieren(n); else alle(n); } });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'alt'] });
    document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') markieren(e.target); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
/* <<< EG-NAHAUFNAHME */

